import { render, staticRenderFns } from "./UserTrainingCourseChangeActivationType.vue?vue&type=template&id=4ca12ea8&"
import script from "./UserTrainingCourseChangeActivationType.vue?vue&type=script&lang=js&"
export * from "./UserTrainingCourseChangeActivationType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports